<template>
  <ims-page>
    <!-- Page Header -->
    <template v-slot:header>
      <ims-toolbar>
        <template v-slot:left>
          <ims-menu-button />
        </template>
        <span class="title md">
          Welcome Race Fans!
          <span class="note">INDYCAR Fantasy Challenge</span>
        </span>
      </ims-toolbar>
    </template>
    <!-- End Page Header -->

    <main class="home container">
      <ims-button
        type="solid"
        color="primary"
        size="lg"
        class="btn-block my-3"
        to="/home"
        v-if="$User.loggedIn"
        >Play Now</ims-button
      >

      <ims-button
        type="solid"
        color="primary"
        size="lg"
        class="btn-block my-3"
        @click="$store.dispatch('user/login')"
        v-if="!$User.loggedIn"
        >Sign up / Login</ims-button
      >

      <div class="legal">
        LEGAL DISCLAIMER: Lorem ipsum dolor sit amet, consectetur adipiscing
        elit ut aliquam
      </div>

      <div class="m-4" />
      <div class="ad-space">Ad/Promo</div>
    </main>
  </ims-page>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      view: 'my-team'
    };
  },
  watch: {
    '$store.state.user.loggedIn'() {
      if (loggedIn) {
        this.$router.push('/home');
      }
    }
  },
  methods: {},
  mounted() {
    this.$store.dispatch('document/title', 'Welcome Race Fans!');
  }
};
</script>

<style lang="scss">
@import '../scss/utils/variables';

.container.home {
  .logo {
    max-width: 270px;
    margin: 40px auto;
  }
  .legal {
    max-width: 270px;
    margin: 20px auto;
    text-align: center;
    font-size: $font-sm;
  }
  .ad-space {
    max-width: 300px;
    height: 180px;
    // background-color: rgba(0, 0, 0, 0.1);
    color: rgba(0, 0, 0, 0.4);
    border-radius: 6px;
    margin: 10px auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
